import './ProjectStatsFilters.scss';
import { ReactElement } from 'react';
import { TimePeriodSelectorContainer } from './timePeriodSelector/TimePeriodSelector.container';
import { WorkerSelectorContainer } from './workerSelector/WorkerSelector.container';
import { WorkspaceTimezoneContainer } from './workspaceTimezone/WorkspaceTimezone.container';

export const ProjectStatsFilters = (): ReactElement => (
  <div className='project-stats-filters'>
    <WorkerSelectorContainer />
    <TimePeriodSelectorContainer />
    <WorkspaceTimezoneContainer />
  </div>
);
